import { Http, Response } from '@angular/http'
import { TranslateLoader } from '@ngx-translate/core'
import { Observable } from 'rxjs/Observable'
import { FirebaseApp } from 'angularfire2/app'

export class TranslateFirebaseLoader implements TranslateLoader {

  constructor(private app: FirebaseApp,
    private http: Http,
    private prefix: string = '',
    private suffix: string = '.json') {

  }

  getTranslation(lang: string): Observable<any> {
    const ref = this.app.storage().ref(`${this.prefix}${lang}${this.suffix}`)

    const promise = ref.getDownloadURL() as Promise<any>
    return Observable
      .fromPromise(promise)
      .switchMap((url: string) => {
        return this.http.get(url)
      })
      .map((response: Response) => {
        return response.json()
      })
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/translate-firebase-loader.ts